import { useEffect, useState } from "react";
import { Instagram, Mail, MessageCircle } from "lucide-react";
import api from "@/lib/api";
import PublicLayout from "@/components/layout/PublicLayout";

export default function Contato() {
  const [s, setS] = useState({});
  useEffect(() => {
    document.title = "Contato — Ana Paula Moraes";
    api.get("/settings").then((r) => setS(r.data || {}));
  }, []);

  return (
    <PublicLayout>
      <section className="py-20 md:py-28">
        <div className="max-w-4xl mx-auto px-6 lg:px-12 text-center fade-in-up">
          <div className="eyebrow mb-4">Vamos conversar</div>
          <h1 className="font-serif text-4xl md:text-6xl mb-6 leading-tight" style={{ color: "var(--text-primary)" }}>
            Conte-me onde você está. <em className="italic" style={{ color: "var(--copper)" }}>Eu te ouço.</em>
          </h1>
          <p className="text-lg leading-relaxed mb-12" style={{ color: "var(--text-secondary)" }}>
            Escolha o canal que faz sentido para você.
          </p>

          <div className="grid md:grid-cols-3 gap-6">
            {s.instagram && (
              <a href={s.instagram} target="_blank" rel="noreferrer" className="brand-card p-8 hover:shadow-xl block" data-testid="contact-instagram">
                <Instagram size={28} style={{ color: "var(--rose-gold)" }} className="mx-auto mb-4" />
                <div className="font-serif text-xl mb-1">Instagram</div>
                <div className="text-sm" style={{ color: "var(--text-secondary)" }}>@eusouanapaulam</div>
              </a>
            )}
            {s.whatsapp && (
              <a href={`https://wa.me/${s.whatsapp.replace(/\D/g, "")}`} target="_blank" rel="noreferrer" className="brand-card p-8 hover:shadow-xl block" data-testid="contact-whatsapp">
                <MessageCircle size={28} style={{ color: "var(--rose-gold)" }} className="mx-auto mb-4" />
                <div className="font-serif text-xl mb-1">WhatsApp</div>
                <div className="text-sm" style={{ color: "var(--text-secondary)" }}>{s.whatsapp}</div>
              </a>
            )}
            {s.email && (
              <a href={`mailto:${s.email}`} className="brand-card p-8 hover:shadow-xl block" data-testid="contact-email">
                <Mail size={28} style={{ color: "var(--rose-gold)" }} className="mx-auto mb-4" />
                <div className="font-serif text-xl mb-1">E-mail</div>
                <div className="text-sm" style={{ color: "var(--text-secondary)" }}>{s.email}</div>
              </a>
            )}
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
